export default __webpack_public_path__ + "3067908af4f307e7ddffa976ef92f7a4.png";